import { render, staticRenderFns } from "./TUIShippingStateChip.vue?vue&type=template&id=523a0ab4"
import script from "./TUIShippingStateChip.vue?vue&type=script&lang=js"
export * from "./TUIShippingStateChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports